<template>
  <section class="pay-period">
    <div class="period">
      <span class="label-ui"
        >预付定金<i class="icon-tip-red ml10" @click="tipAlert"></i
      ></span>
      <span class="pre-price">&yen;{{ prePrice }}</span>
    </div>
    <div class="pay">
      <span class="label-ui"
        >剩余尾款<template
          v-if="hasUseBlackGoldPrice && product.blackGoldUser == 1"
        >
          （黑金会员价）</template
        ></span
      >
      <span class="next-price">&yen;{{ nextPrice }}</span>
    </div>
    <div class="tips">*若有优惠，优惠价将在支付尾款时享受</div>
  </section>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { Msgbox } from 'kf-component-vue'
import { round } from 'lodash'

export default {
  props: {
    product: {
      type: Object,
      default: () => {}
    },
    hasUseBlackGoldPrice: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      discountChecked: false,
      callOnce: false,
      discountReadOnly: false
    }
  },
  computed: {
    ...mapState(['payPrice']),
    //预付定金
    prePrice() {
      let price = 0
      if (
        this.product &&
        this.product.skuInfo &&
        this.product.skuInfo.payPeriodInfo &&
        this.product.skuInfo.payPeriodInfo.paymentDepositPrice
      ) {
        price = this.product.skuInfo.payPeriodInfo.paymentDepositPrice
      }

      if (price < 0) price = 0
      return `${price / 100}`
    },
    //尾款
    nextPrice() {
      let price = this.payPrice - this.prePrice * 100
      if (price < 0) price = 0
      return `${round(price / 100, 2)}`
    }
  },
  methods: {
    tipAlert() {
      const desc =
        '定金，指预先支付一定数额的金钱，用作购买孩子王商品的担保和确定购买名额；尾款，指孩子王商品价格减去定金后买家还需支付的金额。其中优惠券等优惠，付定金时已锁定，在支付尾款时享受。'
      Msgbox({
        title: '温馨提示',
        message: desc,
        confirmButtonText: '我知道了',
        confirmButtonClass: 'confirmButton'
      })
    }
  },
  components: {},
  beforeDestroy() {}
}
</script>
<style lang="scss">
@import '~@/assets/css/mixin';
.kfcv-msgbox-message {
  text-align: left !important;
}
.pay-period {
  background-color: #fff;
  border-radius: rem(16px);
  padding: rem(40px) rem(24px);
  .period {
    display: flex;
    justify-content: space-between;
    .pre-price {
      font-weight: bold;
      font-size: rem(26px);
      color: #ff5900;
    }
  }
  .pay {
    display: flex;
    justify-content: space-between;
    margin-top: rem(24px);
    .next-price {
      font-weight: bold;
      font-size: rem(26px);
      color: #262626;
    }
  }
  .tips {
    margin-top: rem(10px);
    font-size: rem(22px);
    color: #ff6d00;
  }
}
.label-ui {
  display: flex;
  align-items: center;
  font-size: rem(26px);
  color: #262626;
}
.confirmButton.confirmButton {
  color: #ff5900;
  font-size: rem(32px);
  font-weight: bold;
}
</style>
